// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copyIcon {\r\n    margin-left: 5px;\r\n    cursor: pointer;\r\n}", "",{"version":3,"sources":["webpack://./../../libs/remix-ui/clipboard/src/lib/copy-to-clipboard/copy-to-clipboard.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".copyIcon {\r\n    margin-left: 5px;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
